import styled, { css } from 'styled-components';
import { ApButtonIcon, colors } from '@alixpartners/ui-components';

export const RowMenuIcon = styled(ApButtonIcon)`
  visibility: hidden;
  align-self: flex-start;
`;

export const Container = styled.div`
  display: flex;
  align-items: flex-end;
  width: 100%;
  &:hover {
    ${RowMenuIcon} {
      visibility: visible;
    }
  }
`;

export const SelectContainer = styled.div<{ noMargin?: boolean }>`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 294px;
  margin-right: ${(props) => (props.noMargin ? 4 : 12)}px;
`;

export const AllocationContainer = styled(SelectContainer)<{
  highlight: boolean;
}>`
  width: 71px;
  input {
    min-width: 71px;
  }
  ${({ highlight }) =>
    highlight &&
    css`
      input {
        border-color: ${colors.orange};
      }
    `}
`;

export const InputLabel = styled.div`
  font-size: 13px;
  font-weight: 400;
  color: ${colors.grey5};
  margin-bottom: 4px;
`;

export const Equal = styled.div`
  display: flex;
  align-items: flex-start;
  align-self: baseline;
  height: 100%;
  font-size: 34px;
  margin-right: 12px;
`;

export const ErrorMessage = styled.div<{ visible?: boolean }>`
  font-size: 11px;
  width: 100%;
  color: ${colors.red1};
  height: 26px;
  visibility: ${(props) => (props.visible ? 'visible' : 'hidden')};
  margin-top: 8px;
`;

export const WarningMessage = styled(ErrorMessage)`
  color: ${colors.grey8};
  visibility: visible;
`;
